/**
 * Keeps the shadcn `.dark` class on <html> in sync with the OS colour-scheme
 * preference. The app has no manual toggle, so this preserves the previous
 * behaviour of following the system theme.
 */
export function syncSystemTheme(): () => void {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return () => {};
  }
  const query = window.matchMedia('(prefers-color-scheme: dark)');
  const apply = () => {
    document.documentElement.classList.toggle('dark', query.matches);
  };
  apply();
  query.addEventListener('change', apply);
  return () => query.removeEventListener('change', apply);
}
